<template>
  <div class="vip-creator">
    <el-dialog
      :style="{ opacity: this.vipPaneShow ? 0 : 1 }"
      custom-class="vip-creator-modal"
      :visible.sync="visible"
      append-to-body
      width="360px"
      :show-close="!isThird"
      :before-close="done => isThird ? '' : done()"
    >
      <template v-if="isThird">
        <div class="vip-creator-container">
          <h2>请联系客服开通或续费此模块。</h2>
          <el-button v-if="thirdVipUrl" class="vip-creator-btn is-primary" @click="routeToThirdVipPage(thirdVipUrl)">
            <span>开通/续费</span>
          </el-button>
        </div>
      </template>
      <div class="vip-creator-container" v-else-if="isExpired">
        <template v-if="isEnterprise">
          <h2>您的团队套餐已过期</h2>
          <el-button class="vip-creator-btn is-primary" @click="routeToContractProduct">
            <span>续费/升级团队套餐</span>
          </el-button>
        </template>
        <template v-else>
          <h2>您的VIP套餐已过期</h2>
          <el-button class="vip-creator-btn is-primary" @click="vipPaneShow = true">
            <span>开通VIP</span>
          </el-button>
        </template>
      </div>
      <div class="vip-creator-container" v-else-if="isLimit">
        <h2>您的免费体验次数已用完，立即开通VIP，享更多特权！</h2>
        <el-button class="vip-creator-btn is-primary" @click="vipPaneShow = true">
          <span>开通VIP</span>
        </el-button>
        <el-button class="vip-creator-btn" @click="visible = false">
          <span>暂不开通</span>
        </el-button>
      </div>
      <div class="vip-creator-container" v-else-if="isOut">
        <h2>您的当前请求次数已达上限，请明天再来。</h2>
        <el-button class="vip-creator-btn" @click="visible = false">
          <span>关闭</span>
        </el-button>
      </div>
    </el-dialog>

    <vipPane v-if="vipPaneShow" :show.sync="vipPaneShow" :vipType="vipType" />
  
  </div>
</template>

<script>
import vipPane from '@/components/vipPane';
import { mapGetters } from 'vuex';
import { projectInfoConfig } from '@/constant'

export default {
  components: { vipPane },
  data() {
    return {
      vipPaneShow: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    vipType: {
      type: String,
      required: true,
      validator: val => ['law', 'case', 'forecast'].includes(val)
    },
    limitType: {
      type: String,
      default: ''
    },
    justClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isEnterprise', 'isThird']),
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (this.isEnterprise) {
          this.routeToContractProduct();
          return;
        }
        if (this.justClose) {
          this.$emit('update:show', val);
        } else {
          this.focusClostHandle();
        }
      }
    },
    isExpired() {
      return this.limitType === 'DATE';
    },
    isLimit() {
      return this.limitType === 'NUMBER';
    },
    isOut() {
      return this.limitType === 'DATE_NUMBER';
    },
    thirdVipUrl() {
      const urlConfig = {
        'forecast': projectInfoConfig.forecastVipUrl
      }
      
      return urlConfig[this.vipType] || '';
    }
  },
  methods: {
    focusClostHandle() {
      if (this.vipType === 'law') {
        this.$router.push({ name: 'mainSearch' });
      }
      if (this.vipType === 'case') {
        this.$router.push({ name: 'caseSearch' });
      }
      if (this.vipType === 'forecast') {
        this.$emit('update:show', false);
        if (this.$route.name !== 'forecastDashboard') {
          this.$router.push({
            path: '/forecast/dashboard'
          })
        }
      }
    },
    routeToContractProduct() {
      localStorage.setItem('_ENTERPRISE_ID_', this.$store.state.vip.enterpriseInfo.id);
      location.href = `${location.origin}${projectInfoConfig.contractUrl}/product`;
    },
    routeToThirdVipPage(url) {
      this.focusClostHandle();
      window.open(`${location.origin}${url}`, '_blank');
    }
  }
};
</script>

<style lang="less">
.vip-creator-modal {
  .el-dialog__header {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.vip-creator-container {
  padding: 10px 25px 5px;

  h2 {
    text-align: center;
    color: #172237;
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 40px;
  }

  .vip-creator-btn {
    display: block;
    font-size: 16px;
    width: 200px;
    margin: 20px auto 0;
    color: #4E555B;
    border-color: #DBDFE9 !important;
    background-color: #fff;

    &.is-primary{
      color: #fff;
      background-color: #3F6EFC !important;
      border-color: #3F6EFC !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vipCreator.vue